<template>
    <CommonChart
        :data="processedData"
        :config="chartConfig"
        :xAxisUnit="getXAxisUnit"
        container-class="chart-container"
        height="200px"
    />
</template>

<script>
import CommonChart from "../common/CommonChart.vue";

export default {
    name: "BillMonthlyTrendChart",
    components: {
        CommonChart,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        selectedPeriod: {
            type: String,
            default: "monthly",
        },
    },
    computed: {
        getXAxisUnit() {
            if (this.selectedPeriod === "monthly") {
                return "monthly";
            }
            return "yearly";
        },
        // 실제 청구요금과 예상요금을 구분해서 처리
        processedData() {
            if (!this.data) return [];

            return this.data.map((item) => {
                return {
                    ...item,
                    // 실제 청구 금액 (0이면 null)
                    reqAmt: item.reqAmt > 0 ? item.reqAmt : null,
                    // 예상 청구 금액 (0이면 null)
                    predAmt: item.predAmt > 0 ? item.predAmt : null,
                    // 실제 단위 금액 (0이면 null)
                    unitPrice: item.unitPrice > 0 ? item.unitPrice : null,
                    // 예상 단위 금액 (0이면 null)
                    predUnitPrice: item.predUnitPrice > 0 ? item.predUnitPrice : null,
                };
            });
        },
        chartConfig() {
            if (!this.processedData) return [];
            // reqAmt와 predAmt 중 최댓값 계산
            const maxAmount =
                this.processedData.length > 0
                    ? Math.max(...this.processedData.map((item) => Math.max(item.reqAmt || 0, item.predAmt || 0)))
                    : 0;
            const yAxisMax = Math.ceil(maxAmount * 1.1); // 최대값의 110%로 설정하여 여백 확보

            // unitPrice와 predUnitPrice 중 최댓값 계산
            const maxUnitPrice =
                this.processedData.length > 0
                    ? Math.max(
                          ...this.processedData.map((item) => Math.max(item.unitPrice || 0, item.predUnitPrice || 0))
                      )
                    : 0;
            const yAxisMaxUnitPrice = Math.ceil(maxUnitPrice * 1.1);

            return [
                {
                    name: "청구 금액",
                    type: "bar",
                    dataField: "reqAmt",
                    predField: "predAmt", // 예상 금액 필드 추가
                    overlap: true, // 실제 청구 위에 예상 청구 겹치기
                    color: "#3b82f6",
                    predColor: "#BDBDBD", // 예측 데이터 색상
                    predOpacity: 0.6, // 예측 바 투명도
                    borderRadius: [20, 20, 0, 0],
                    barWidth: "60%",
                    yAxisIndex: 0,
                    yAxis: {
                        name: "금액(원)",
                        formatter: (value) =>
                            value.toLocaleString("ko-KR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
                            "원",
                        max: yAxisMax,
                    },
                },
                {
                    name: "단위 금액",
                    type: "line",
                    dataField: "unitPrice",
                    predField: "predUnitPrice", // 예상 단위 금액 필드 추가
                    color: "#78909C",
                    predColor: "#BDBDBD", // 예측 데이터 색상
                    yAxisIndex: 1,
                    lineStyle: {
                        type: "dashed", // 점선
                        width: 2,
                    },
                    areaStyle: {
                        color: "transparent",
                    },
                    smooth: true,
                    yAxis: {
                        name: "단위 금액(원/kWh)",
                        formatter: (value) =>
                            value.toLocaleString("ko-KR", { minimumFractionDigits: 0, maximumFractionDigits: 0 }) +
                            "원/kWh",
                        max: yAxisMaxUnitPrice,
                    },
                },
            ];
        },
    },
};
</script>

<style scoped>
.chart-container {
    height: 230px;
    width: 100%;
    flex: 1;
    background: transparent;
    border-radius: 8px;
}
</style>
